import React, { createContext, useContext } from 'react'
import useProvideBlockchain, { BlockchainContext } from './ProvideBlockchain.State'

interface ProvideBlockchainProps {
  children: React.ReactNode
}

const blockchainContext = createContext<BlockchainContext | null>(null)

export const ProvideBlockchain: React.FC<ProvideBlockchainProps> = ({ children }: ProvideBlockchainProps) => {
  const blockchain = useProvideBlockchain()

  return <blockchainContext.Provider value={blockchain}>{children}</blockchainContext.Provider>
}

export const useBlockchain = (): BlockchainContext => {
  const context = useContext(blockchainContext)
  if (!context) {
    throw new Error('useBlockchain must be used within a ProvideBlockchain')
  }
  return context
}
